import m from "../../geodata/es2015/boliviaHigh";
window.am4geodata_boliviaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/boliviaHigh.js
// module id = null
// module chunks = 